export const baseURL = "https://merchantapi.blockbolt.io/api/";
export const baseImageURL = "https://merchantapi.blockbolt.io";
export const redirectURL = "https://checkout.blockbolt.io/";
export const backToMerchant = "https://merchant.blockbolt.io";
export const backToStore = "https://store.blockbolt.io";
export const backToPaylink = "https://paymentlink.blockbolt.io";
export const toBasePayURL = "https://pay.blockbolt.io";
export const siteRecaptchaKey = "6LcoEuYpAAAAAPjoX235t_YJDem9bYosiRt_qnwG";

export const STORE_KEY = process.env.REACT_APP_KEY;